import {ApiClient} from '@hconnect/apiclient'
import {stringify} from 'qs'

import {RequestFunc, YearlyDataPointsPayload, YearlyHierarchyAnalysisDataPoint} from '../../types'

import {loggingDecorator} from './decorators'

const getYearlyDataPointsImpl: RequestFunc<
  YearlyDataPointsPayload,
  YearlyHierarchyAnalysisDataPoint[]
> = async ({from, to, hierarchyIds, questionDifficulties, sectionIds}) => {
  const {data} = await ApiClient.axiosInstance.get<YearlyHierarchyAnalysisDataPoint[]>(
    '/pom-questionnaires/analyses/yearly-data-points',
    {
      params: {
        from,
        to,
        hierarchyIds,
        questionDifficulties,
        sectionIds
      },
      paramsSerializer: (params) => stringify(params, {arrayFormat: 'repeat'})
    }
  )
  return data
}

export const getYearlyDataPoints = loggingDecorator(getYearlyDataPointsImpl)
